import SglTable from "components/ToolkitTable/SglTable"
import React from "react"
import { Badge } from "reactstrap"

const columns = [
  {
    dataField: "customer",
    text: "Cliente",
    sort: true,
  },
  {
    dataField: "status",
    text: "Status",
    sort: true,
    formatter: (cell) => {
      if (!cell || cell === "TOTAL_ROW") return null;

      const isFinished = cell === "CONCLUÍDO";
      const color = isFinished ? "success" : "warning"; 
      const text = isFinished ? "Concluído" : "Em Aberto";
      
      return (
        <Badge className="badge-lg" color={color} pill>
          {text}
        </Badge>
      );
    },
  },
  {
    dataField: "hourlyRate",
    text: "Valor Hora",
    sort: true,
  },
  {
    dataField: "maxCostHour",
    text: "Custo Hr Máximo",
    sort: true,
  },
  {
    dataField: "performedHours",
    text: "Horas Realizadas",
    sort: true,
  },
  {
    dataField: "pastDueHours",
    text: "Horas Vencidas",
    sort: true,
  },
  {
    dataField: "billedHours",
    text: "Horas Faturadas",
    sort: true,
  },
  {
    dataField: "maximumCost",
    text: "Custo Máximo",
    sort: true,
  },
  {
    dataField: "performedCost",
    text: "Custo Realizado",
    sort: true,
  },
  {
    dataField: "pastDueCost",
    text: "Custo Vencido",
    sort: true,
  },
  {
    dataField: "difference",
    text: "Diferença",
    sort: true,
  },
]

function ServiceDeskTable(props) {
  return (
    <>
      {props.data && props.data.length > 0 && (
        <SglTable
          className="serviceDeskTable"
          columns={columns}
          data={props.data}
          rowClick={() => {}}
        />
      )}
    </>
  )
}

export default ServiceDeskTable